import { makeAutoObservable } from "mobx";
import { NotebookStore } from './NotebookStore';

export class SearchStore {
  public searched: string;
  public readonly notebook: NotebookStore;

  public constructor(notebook: NotebookStore) {
    this.notebook = notebook;
    this.searched = "";

    makeAutoObservable(this);
  }

  public get hits(): string[] {
    const s = this.searched.toLocaleLowerCase();
    const subjects = this.notebook.conceptNames;

    return subjects.filter((subject) =>
      subject.toLocaleLowerCase().includes(s)
    );
  }
}
